/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React, { useState } from 'react';
import { Button, Row, Col, Form, Modal, Input } from 'antd';
import Select from 'antd/es/select';
import { useSelector } from 'react-redux';

import botIconRedOutlined from '@svg/botIconRedOutlined.svg';
import botIcon from '@svg/botIcon.svg';
import { formatDateTime } from '@utils/format/dates';
import { MESSAGES } from '@translations/labels';
import { idField } from '@constants';
import { getSummary } from './release.helper';
import { useGetAgents } from 'commons/hooks/useGetAgents';
import { useReleases } from '../../hooks/useReleases';
import { useReleaseSetStable } from '../../hooks/useReleaseSetStable';
import { useReleaseCreation } from '../../hooks/useReleaseCreation';
import stableReleaseFormStyles from './stableReleaseFormStyles';
import { useReleaseLoad } from '../../hooks/useReleaseLoad';
import { useFlowVersionsGet } from '../../hooks/useFlowsVersion';
import { useCorpusVersionGet } from 'commons/hooks/useCorpusVersion';
import { useVdnVersionGet } from 'commons/hooks/useVdnVersion';

const labels = { ...MESSAGES.manageBot.releasesPage };

const StableReleaseForm = () => {
  const [releaseForm] = Form.useForm();
  const { Option } = Select;
  const corpusVersionsResult = useCorpusVersionGet();
  const flowReleasesResult = useFlowVersionsGet();
  const { setStableRelease } = useReleaseSetStable();
  const { createBotRelease } = useReleaseCreation();
  const { versions: vdnVersions } = useVdnVersionGet();
  const botSubscriptions = useSelector(state => state.agents.botSubscriptions);
  const [hasToNotify, setNotifications] = useState(false);
  const [currentCorpusVersionSummary, setCorpusVersionSummary] = useState();
  const [currentFlowsVersionSummary, setFlowsVersionSummary] = useState();
  const [currentSummary, setSummary] = useState();
  const [releaseName, setReleaseName] = useState();
  const [typedReleaseNameLength, setTypedReleaseNameLength] = useState(0);
  const [stableReleaseValue, setStableReleaseValue] = useState(null);
  const { loadRelease } = useReleaseLoad();
  const { releases } = useReleases();

  useGetAgents();

  let remoteBotUrl;
  if (botSubscriptions && botSubscriptions.length) {
    remoteBotUrl = botSubscriptions[0].botUrl;
  }

  const generateAndSetSummary = (value, releases) => {
    const summaryTxt = getSummary(value, releases);
    if (summaryTxt) {
      console.log('summaryTxt -> ', summaryTxt);
      setSummary(summaryTxt);
    }
  };

  const generateAndSetCorpusVersionSummary = version => {
    if (version) {
      setCorpusVersionSummary(version.releaseDescription);
    } else {
      setCorpusVersionSummary();
    }
  };

  const generateAndSetFlowsVersionSummary = version => {
    if (version) {
      setFlowsVersionSummary(version.releaseDescription);
    } else {
      setFlowsVersionSummary();
    }
  };

  if (corpusVersionsResult && corpusVersionsResult.releases) {
    const currentCorpusRelease = corpusVersionsResult.releases.find(r => r.isCurrentRelease);
    if (currentCorpusRelease && !releaseForm.getFieldValue('corpusVersionToRelease')) {
      releaseForm.setFieldsValue({
        corpusVersionToRelease: currentCorpusRelease[idField],
      });
      generateAndSetSummary(currentCorpusRelease[idField], corpusVersionsResult.releases);
      generateAndSetCorpusVersionSummary(currentCorpusRelease);
    }
  }

  let flowReleasesOptions = [];

  if (flowReleasesResult && flowReleasesResult.releases) {
    flowReleasesOptions = [...flowReleasesOptions, ...flowReleasesResult.releases];
    const currentFlowRelease = flowReleasesResult.releases.find(r => r.isCurrentRelease);
    if (currentFlowRelease && !releaseForm.getFieldValue('flowVersionToRelease')) {
      releaseForm.setFieldsValue({
        flowVersionToRelease: currentFlowRelease[idField],
      });
      generateAndSetFlowsVersionSummary(currentFlowRelease);
    }
  }

  if (vdnVersions && vdnVersions.length && !releaseForm.getFieldValue('vdnVersionToRelease')) {
    releaseForm.setFieldsValue({
      vdnVersionToRelease: vdnVersions[0]._id,
    });
  }

  const handleStableVersionChange = value => {
    setStableReleaseValue(value);
    const version = corpusVersionsResult.releases.find(r => r[idField] === value);
    generateAndSetSummary(value, corpusVersionsResult.releases);
    generateAndSetCorpusVersionSummary(version);
  };

  const handleFlowsVersionChange = value => {
    setFlowsVersionSummary();
    const version = flowReleasesResult.releases.find(r => r[idField] === value);
    generateAndSetFlowsVersionSummary(version);
  };

  // start release created modal
  const handleCancel = () => {
    Modal.destroyAll();
  };
  const handleLoadInTester = release => () => {
    Modal.destroyAll();
    loadRelease(release[idField]);
  };
  const openReleaseCreatedLoadInTesterModal = release => {
    Modal.destroyAll();
    const modalSettings = {
      icon: false,
    };
    const contentSettings = {
      wrapClassName: 'test-modal',
      onCancel: handleCancel,
      width: 600,
      footer: [
        <Button
          key="submit"
          type="secondary"
          style={{ color: '#ef6461', border: '2px solid #ef6461' }}
          icon={<img src={botIconRedOutlined} height="24px" style={{ marginBottom: '6px', marginRight: '6px' }} />}
          className="uppercase"
          onClick={handleLoadInTester(release)}
        >
          Load release in Test the bot
        </Button>,
      ],
    };
    Modal.info({
      ...modalSettings,
      content: (
        <Modal title={<b>The release was created successfully!</b>} visible {...contentSettings} type="secondary">
          <div style={{ display: 'flex' }}>
            <img src={botIcon} style={{ height: '68px' }} />
            <p>
              You should always test the release before deploying it to production. Would you like to "Test the bot"
              right away?
            </p>
          </div>
        </Modal>
      ),
    });
  };
  // end modal

  const handleCreateRelease = values => {
    if (values.corpusVersionToRelease) {
      console.log('handleCreateRelease...', values);
      createBotRelease(values.corpusVersionToRelease, values.flowVersionToRelease, values.releaseName, values.vdnVersionToRelease);
      releaseForm.setFieldsValue({ releaseName: undefined });
      setReleaseName(values.releaseName);
    }
  };
  if (releaseName && releases && releases.length) {
    const release = releases.find(release => release.name === releaseName);
    if (release && releaseName) {
      setReleaseName();
      openReleaseCreatedLoadInTesterModal(release);
    }
  }
  return (
    <>
      <header className="header-release-page">
        <h4 className="uppercase">{labels.newRelease}</h4>
      </header>
      <Form
        name="stable-release"
        form={releaseForm}
        onFinish={handleCreateRelease}
        initialValues={{
          corpusVersionToRelease: stableReleaseValue,
          notifier: true,
        }}
      >
        <Row>
          <Col>
            <header className="header-release-page">
              <h5>{labels.corpusVersion}</h5>
            </header>
            <Row gutter={20}>
              <Col>
                <Form.Item
                  name="corpusVersionToRelease"
                  className="release-drowdown"
                  rules={[
                    {
                      required: true,
                      message: labels.formSelectReleaseMessage,
                    },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder={labels.formSelectStableReleasePlaceholder}
                    onChange={handleStableVersionChange}
                    style={{ width: 550 }}
                  >
                    {corpusVersionsResult.releases.map(releaseItem => (
                      <Option key={releaseItem[idField]} value={releaseItem[idField]}>
                        ({formatDateTime(releaseItem.releaseDate)}) {releaseItem.releaseTitle}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <div className="release-summary">{currentSummary}</div>
              </Col>
            </Row>
          </Col>
          <Col>
            <p className="corpus-description">
              <strong>Corpus description:</strong>
            </p>
            <p>{currentCorpusVersionSummary}</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <header className="header-release-page">
              <h5>{labels.flowsVersion}</h5>
            </header>
            <Row gutter={20}>
              <Col>
                <Form.Item
                  name="flowVersionToRelease"
                  className="release-drowdown"
                  rules={[
                    {
                      required: true,
                      message: labels.formSelectReleaseMessage,
                    },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder={labels.formSelectFlowReleasePlaceholder}
                    onChange={handleFlowsVersionChange}
                    style={{ width: 550 }}
                  >
                    {flowReleasesOptions.map(releaseItem => (
                      <Option key={releaseItem[idField]} value={releaseItem[idField]}>
                        {releaseItem.releaseDate !== '' ? `(${formatDateTime(releaseItem.releaseDate)})` : ' '}{' '}
                        {releaseItem.releaseTitle}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col>
            <p className="flows-description">
              <strong>Flows description:</strong>
            </p>
            <p>{currentFlowsVersionSummary}</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <header className="header-release-page">
              <h5>VDN Version</h5>
            </header>
            <Row gutter={20}>
              <Col>
                <Form.Item
                  name="vdnVersionToRelease"
                  className="release-drowdown"
                  rules={[
                    {
                      required: true,
                      message: 'Please select a VDN version',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder="Select a VDN version"
                    style={{ width: 550 }}
                  >
                    {vdnVersions.map(version => (
                      <Option key={version._id} value={version._id}>
                        ({formatDateTime(version.createdAt)}) {version.version_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="release-name">
          <Col>
            <header className="header-release-page">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h5>{labels.releaseName}</h5>
                <div style={{ marginTop: '12px' }}>{typedReleaseNameLength}/55</div>
              </div>
            </header>
            <Form.Item
              name="releaseName"
              rules={[
                {
                  required: true,
                  message: labels.formatReleaseNameMessage,
                },
              ]}
              style={{ marginBottom: 0 }}
              shouldUpdate
            >
              <Input
                placeholder={labels.formReleaseNamePlaceholder}
                autoComplete="off"
                maxLength="55"
                style={{ width: 550 }}
                allowClear
                onChange={e => {
                  console.log(e.target.value.length);
                  setTypedReleaseNameLength(e.target.value.length);
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="uppercase release-button">
                {labels.btnAddRelease}
              </Button>
            </Form.Item>
          </Col>
          {/**
           <div className="notifier-switch">
            <Form.Item name="notifier" label={labels.switchNotify} className="flex column">
              <Switch checked={hasToNotify} onChange={() => setNotifications(!hasToNotify)} />
            </Form.Item>
          </div>
           */}
        </Row>
        <style jsx>{stableReleaseFormStyles}</style>
      </Form>
    </>
  );
};

export { StableReleaseForm };
